import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

type ClientNotesPreviewModalProps = {
  isOpen: boolean;
  notes: string;
  clientName?: string | null;
  onClose: () => void;
};

const ClientNotesPreviewModal: React.FC<ClientNotesPreviewModalProps> = ({
  isOpen,
  notes,
  clientName,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered size="lg">
      <ModalHeader toggle={onClose}>
        {clientName
          ? t("clients.notesPreview.titleWithName", { name: clientName })
          : t("clients.notesPreview.title")}
      </ModalHeader>
      <ModalBody>
        <p className="text-muted small mb-2">{t("clients.notesPreview.hint")}</p>
        <div
          className="border rounded p-3 bg-light"
          style={{ whiteSpace: "pre-wrap", maxHeight: "60vh", overflowY: "auto" }}
          data-clarity-mask="true"
        >
          {notes.trim()}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={onClose}>
          {t("clients.notesPreview.close")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ClientNotesPreviewModal;
